"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateEntry201ResponseToJSON = exports.CreateEntry201ResponseFromJSONTyped = exports.CreateEntry201ResponseFromJSON = exports.instanceOfCreateEntry201Response = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateEntry201Response interface.
 */
function instanceOfCreateEntry201Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateEntry201Response = instanceOfCreateEntry201Response;
function CreateEntry201ResponseFromJSON(json) {
    return CreateEntry201ResponseFromJSONTyped(json, false);
}
exports.CreateEntry201ResponseFromJSON = CreateEntry201ResponseFromJSON;
function CreateEntry201ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : json['data'],
    };
}
exports.CreateEntry201ResponseFromJSONTyped = CreateEntry201ResponseFromJSONTyped;
function CreateEntry201ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data,
    };
}
exports.CreateEntry201ResponseToJSON = CreateEntry201ResponseToJSON;
